.page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-4, 1rem);
}

.card {
  width: 100%;
  max-width: 24rem;
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--radius-sharp);
  box-shadow: var(--shadow-soft);
  padding: 1.5rem;
}

.mark {
  font-family: var(--font-display);
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--teal-600);
  margin: 0 0 1.25rem;
}

.title {
  font-family: var(--font-display);
  font-size: 1.375rem;
  margin: 0 0 0.25rem;
}

.lede {
  color: var(--ink-soft);
  font-size: var(--text-min-body);
  margin: 0 0 1.25rem;
}

/*
 * The form's own rhythm. Every customer form had zero vertical gap between
 * fields, so a field's label sat flush against the input above it and read as
 * a caption for the wrong control.
 */
.form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: stretch;
}

/*
 * A secondary escape hatch must not out-shout the primary action. "Use a
 * different number" was a full-chrome browser button sitting under a disabled
 * "Sign in", which inverted the hierarchy of the only two controls on screen.
 */
.quietAction {
  background: none;
  border: none;
  padding: 0.25rem 0;
  font-family: var(--font-body);
  font-size: var(--text-min-body);
  color: var(--teal-600);
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
  align-self: center;
}

.quietAction:hover {
  color: var(--teal-700);
}

.quietAction:focus-visible {
  outline: 2px solid var(--cy-500);
  outline-offset: 2px;
}

.error {
  color: var(--stop);
  font-size: var(--text-min-body);
  margin: 0;
}

.footnote {
  color: var(--muted);
  font-size: var(--text-min-mono);
  margin: 1.25rem 0 0;
}
